// Shared by both Bulk Targeting and Bulk Termination - the underlying "which project types
// does this bulk action support" concept is identical between the two features.
export enum BulkProjectTypeEnum {
  County = "county",
  Zip = "zip",
}
